module.exports = __webpack_public_path__ + "media/logos/cuk_logo_white@2x-748d86db.png";